import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

// Draws a consensus/capacity scatter chart from a Chart.js config built in PartnershipReportHelper.
export default class extends Controller {
  static values = { config: Object }

  connect() {
    const config = this.configValue
    const isDarkMode = document.documentElement.classList.contains('dark') ||
                       window.matchMedia('(prefers-color-scheme: dark)').matches
    const textColor = isDarkMode ? '#94a3b8' : '#64748b'
    const gridColor = isDarkMode ? 'rgba(148, 163, 184, 0.2)' : 'rgba(100, 116, 139, 0.2)'

    Object.values(config.options.scales).forEach((scale) => {
      scale.ticks = { ...scale.ticks, color: textColor }
      scale.title = { ...scale.title, color: textColor }
      scale.grid = { color: gridColor }
    })

    this.chart = new Chart(this.element, config)
  }

  disconnect() {
    this.chart?.destroy()
  }
}
